import { create } from 'zustand';
import { Actions, Countries, CountryCurrencies, Currencies, ModeType, NameIdSub, State, StringMap } from '../types/types.js';
import PostMessage from '../PostMessage.js';
// import zukeeper from "zukeeper";

const initialState: State = {
  page: 1,
  steps: [],
  fun: {
    required: {},
    optional: {},
  },
  lang: "en",
  real: {
    required: {},
    optional: {},
  },
  dirty: {},
  errors: {},
  suggestions: [],
  additional: false,
  step1: {
    login: null,
    email: null,
    password: null,
  },
  step2: {
    sex: null,
    user_title_id: null,
    fname: null,
    lname: null,
    birth_date: null,
    home_phone: null,
    work_phone: null,
    cell_phone: null,
  },
  step3: {
    address: null,
    address2: null,
    city: null,
    province_id: null,
    country_id: null,
    post_code: null,
    currency: null,
    question: null,
    answer: null,
    ofage: null,
    allow_email: null,
  },
  step4: {
    agree_terms: null,
  },
  step5: {
    cell_phone_edit: null,
    sms_code: null,
    phone_verification: null,
    skipped: false,
  },

  // step2
  title_ids: [], // Vec<T> where T: { id: int, name: String, sub_id: ?int }
  titles: [],

  // step3
  provinces: {}, // HashMap<int, Vec<T>> where T: { id: int, name: String }
  regions: {}, // HashMap<int, T> where T: { name: String, sub_id: ?int }
  countries: [], // Vec<T> where T: { id: String, name: String, sub_id: ?int }
  country_currencies: [], // HashMap<int, Vec<Currency>>
  currencies: [],
  default_currency: null,
  tc_markdown: null,
  country_code: null,

  // step 5
  code_sent: false,
  token_received: false,
  phone_edit: false,

  // all
  error: null,
  message: null,
  submitted: false,
  inFlight: false,
  mode: "real",
  emailValidation: false,
  emailVerificationCode: false,
}

let store = (set: any): State & Actions => ({
  ...initialState,
  appendError: (field: string, errorMsg: string) => {
    set((state: State) => ({
      errors: { ...state.errors, [field]: errorMsg }
    }))
  },
  nextPage: () => {
    set((state: State) => {
      PostMessage.setPage((state.page + 1).toString(), (state.step1.login && state.page > 1) ? state.step1.login : undefined);
      return { page: state.page + 1 }
    })
  },
  prevPage: () => {
    set((state: State) => {
      PostMessage.setPage((state.page - 1).toString(), (state.step1.login && state.page > 1) ? state.step1.login : undefined);
      return { page: state.page - 1 }
    })
  },
  resetInflight: (inFlight = false, submitted = false) => {
    set({
      inFlight,
      submitted,
    })
  },
  setMode: (mode: ModeType) => {
    set({
      mode
    })
  },
  setDirty: (fieldname: string) => {
    set((state: State) => ({
      dirty: { ...state.dirty, [fieldname]: true }
    }))
  },
  setError: (error?: string | null, message?: string | null,) => {
    set((state: State) => ({
      error: error ? error : state.error,
      message: message ? message : state.message,

    }))
  },
  setErrors: (errors: StringMap<string>) => { set((state: State) => ({ errors })); },
  setField: (fieldValues: StringMap<string | number>, newErrors?: StringMap<string>) => {
    if (newErrors) {
      set({ errors: newErrors });
    }
    set({ ...fieldValues });
  },
  setInflight: () => {
    set({
      submitted: true,
      inFlight: true,
    })
  },
  setPage: (page: number) => {
    PostMessage.setPage(page.toString(), "");
    set({ page })
  },
  setProvinceOpt: (mode: ModeType) => {
    set((state: State) => ({
      [mode]: {
        required: Object.keys(state[mode].required).reduce(
          (res, k) => (k === "province_id" ? { ...res } : { ...res, [k]: true }),
          {}
        ), optional: {
          ...state[mode].optional,
          province_id: true,
        }
      },
      step3: {
        ...state.step3,
        province_id: null,
      }
    }))
  },
  setProvinceReq: (mode: ModeType) => {
    set((state: State) => ({
      [mode]: {
        required: {
          ...state[mode].required,
          province_id: true,
        }, optional: Object.keys(state[mode].optional).reduce(
          (res, k) => (k === "province_id" ? { ...res } : { ...res, [k]: true }),
          {}
        )
      },
      step3: {
        ...state.step3,
        province_id: null,
      }
    }))
  },
  setUserSuggestions: (suggestions: string[]) => {
    set({ suggestions })
  },
  togglePhoneEdit: () => {
    set((state: State) => ({ phone_edit: !state.phone_edit, }))
  },
  requestSmsResponse: (sent: boolean) => {
    set({
      error: null,
      message: null,
      code_sent: sent,
      inFlight: false
    })
  },
  verifySmsResponse: (token: boolean) => {
    set({
      error: null,
      message: null,
      token_received: token,
      inFlight: false,
    })
  },
  setExtraFields: (mode: ModeType, extraFields: StringMap<string>) => {
    set({ [mode]: extraFields })
  },
  setFields: (fields: {
    real: { optional: string[]; required: string[] };
    fun: { optional: string[]; required: string[] };
  }) => {
    set({
      fun: fields.fun,
      real: fields.real,
    })
  },
  appendedExistingUserData: (cellphone: string, country: string, province: string) => {
    set((state: State) => ({
      step2: { ...state.step2, cell_phone: cellphone },
      step3: { ...state.step3, country_id: country, province_id: province },
    }))
  },
  setupInitialVariables: (
    currencies: Currencies[],
    steps: string[],
    countries: Countries[],
    country_currencies: CountryCurrencies[],
    countrycodes: string,
    default_currency: string,
    download_url: string,
    provinces: StringMap<NameIdSub>,
    regions: StringMap<NameIdSub>,
    tc_markdown: string,
    title_ids: number[],
    titles: string[],
    emailValidation: boolean,
    emailVerificationCode: boolean,
  ) => {
    set({
      currencies,
      steps,
      countries,
      country_currencies,
      countrycodes,
      default_currency,
      download_url,
      provinces,
      regions,
      tc_markdown,
      title_ids,
      titles,
      emailValidation,
      emailVerificationCode,
    })
  },
  reset: () => set(initialState)
});
// store = zukeeper(store);

const useRegStore = create<State & Actions>()(store);
window.store = useRegStore;
export default useRegStore;
